
import React, { memo, useContext } from "react";
import { getSystemSettings, getReseredTime } from "../../../../../../functions/Functions"
import Modal from "react-bootstrap/Modal";
import Switch from "react-switch";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as FullTable } from "../../../../public/Full Table.svg";
import { ReactComponent as LeftHalfTable } from "../../../../public/Left Table.svg";
import { ReactComponent as RightHalfTable } from "../../../../public/Right Table.svg";
// import { useFilteredFloorWaiters } from "../hooks/useFilteredFloorWaiters";
import useTableFunctions from "../hooks/useTableFunctions";
import { SettingsContext } from "../../../../../../contexts/Settings";
 
const guestVisitor = [2, 5, 8, 10, 15]
const TableModal = ({
  modal10Show,
  setModal10Show,
  setOrderDetails,
  orderDetails,
  selectedDeliveryType,
  selectTable,
  setSelectTable,
  guestSelected,
  setGuestSelected,
  tableId,
  setTableId,
  selectedParty,
  selectedDeptTag,
  buttonDisabled,
}) => {

  const {
    waiterSelected,
    setWaiterSelected,
    getTableFloor,
    tablefloor,
    setTableFloor,
    multiSelect,
    setMultiSelect,
    tables,
    startDate,
    setStartDate,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    newtable,
    setNewTable,
    handleTableSubmit,
    handleTableSelect,
    handleTableMulitpleSelect,
    handleSplit,
    handleSearchWaiter,
    waitersList,
    order_id,
    tableLoading,
  } = useTableFunctions({
    orderDetails,
    buttonDisabled,
    selectedDeptTag,
    selectedDeliveryType,
    selectedParty,
    setOrderDetails,
    orderDetails,
    setModal10Show,
    selectTable,
    setSelectTable,
    tableId,
    setTableId,
    guestSelected,
    setGuestSelected
  });
  const {generalSettings} = useContext(SettingsContext)
  // let history = useHistory();
  // const { order_id } = useParams();
  // const colorPallete = ["#f3eabc","#ffc7c7","#c0ebe9d1","#edf93278","#C1E6FD","#14ffff4d","#ca26ff63","#f9ad006b"];
  // const [remainingPallete,setRemainingPallete] = useState([]);
  // const { waiters, setWaiters, waiterSelected, setWaiterSelected, getTableFloor, tablefloor, setTableFloor } = useFilteredFloorWaiters(orderDetails);
  
  // const [multiSelect, setMultiSelect] = useState(false);
  // const [tables,setTables] = useState([]);
  // const [tablesApi,setTableApi] = useState([]);
  // const [tempIndex, setTempIndex] = useState(null);
  // const [startDate, setStartDate] = useState(new Date());
  // const [startTime, setStartTime] = useState(new Date());
  // const [endTime, setEndTime] = useState(new Date());

  // //get table with api
  // useEffect(()=>{
  //   if(tableForSearch && orderDetails.branch){
  //     let getTableStatus = tableForSearch && tableForSearch.filter((tableSearch)=>{
  //       return parseInt(tableSearch.branch_id) === orderDetails.branch?.id && tableSearch.status === "1"
  //     });
  
  //     if(!buttonDisabled){
  //       setTables(getTableStatus);
  //       setTableApi(getTableStatus);
  //     }
  
  //     getTableStatus && getTableStatus.map((table)=>{
  //       const index = colorPallete.findIndex((color) => color === (table.is_color));
  //       if(index !== -1){
  //         return colorPallete.splice(index, 1);
  //       }
  //       setRemainingPallete(colorPallete)
  //     });
      
  //     if(order_id && getTableStatus){
  //       const newTable = [...getTableStatus];
  //       let selectedTable = {};
  //       let tabel = orderDetails.table && orderDetails.table?.forEach((table)=>{  
  //         if(getTableStatus && getTableStatus?.length > 0){
  //           const index = getTableStatus.findIndex((tableIndex) => table?.id === tableIndex.id);
  //           newTable[index] && setTempIndex(index);
  //           if(newTable[index].is_reserved === 2 && newTable[index].is_split === 1){
  //             newTable[index] = {...newTable[index],is_reserved : 1};
  //           }else{
  //             newTable[index] = {...newTable[index],is_reserved : 0};
  //           }
  //           selectedTable = {
  //             ...selectedTable,
  //             [table.id] : {
  //               ...table,
  //               ...((table.is_reserved === 2 && table.is_split === 1) ? {is_reserved : 1} : {is_reserved : 0})
  //             }
  //           }
  //         } 
  //       });
  //       setTables( newTable);
  //       setTableApi(newTable);
  //       setSelectTable(selectedTable);
  //     }
  //   }
  // },[tableForSearch, orderDetails?.branch]);
  
  
  // const [newtable,setNewTable] = useState(null);

  // // multi select option
  // useEffect(() => {
  //   if(!buttonDisabled && Object.values(selectTable)[0]){
  //     setTables(tablesApi);
  //     setSelectTable({});
  //     setOrderDetails((curr)=>{
  //       const newData = {
  //         ...curr,
  //         table: null,
  //         waiter: waiterSelected ? waiterSelected : null,
  //         total_guest: guestSelected ? guestSelected : 1,
  //         table_id: null,
  //         table_name: null,
  //       }
  //       return newData 
  //     });
  //   }
  // }, [multiSelect,tablefloor,selectedDeliveryType,orderDetails?.branch,selectedDeptTag,selectedParty]);

  // useEffect(() => {
  //   // search waiter acc to branch
  //   // if (orderDetails.branch) {
  //   //   let tempWaiters =
  //   //     waiterForSearch !== null &&
  //   //     waiterForSearch.filter((eachWaiter) => {
  //   //       return parseInt(eachWaiter.branch_id) === orderDetails?.branch.id;
  //   //     });
  //   //   setWaiter(tempWaiters);
  //   // }

  //   if (order_id) {
  //     setWaiterSelected(orderDetails?.waiter ? orderDetails?.waiter : "");
  //     setGuestSelected(
  //       orderDetails?.total_guest ? parseInt(orderDetails?.total_guest) : 1
  //     );
  //     if(history.location?.search?.startsWith("?table_merge=") || (orderDetails.table && orderDetails.table?.length > 0 && orderDetails.table[0].is_merge)){
  //       setMultiSelect(true);
  //     } 
  //   }
  // }, [selectedDeliveryType, orderDetails?.branch]);

  // //selected tables in state for final playload
  // useEffect(()=>{
  //   if(selectTable){
  //     //let table_Id = [];
  //     let tables = Object.values(selectTable)
  //    // let tableid = Object.keys(selectTable)?.map(id => table_Id.push(parseInt(id)));
  //     let tableid = Object.keys(selectTable)?.map(id => parseInt(id));
  //     setNewTable(tables);
  //     setTableId(tableid);
  //   }
  // },[selectTable]);

  // const handleTableSubmit = (e) => {
  //   e.preventDefault();
  //   const tableValidation = selectedDeliveryType && selectedDeliveryType.name.match(/dine(.*)in/i) &&
  //   parseInt(getSystemSettings(generalSettings, "table_waiter")) === 1;
  //   const waiterOd = getSystemSettings(generalSettings, "waiter_order_type") ? JSON.parse(getSystemSettings(generalSettings, "waiter_order_type")) : null;

  //   if(tableValidation){
  //     if (selectTable && Object.keys(selectTable)?.length > 0) {
  //       if(Object.values(selectTable)[0].is_reserved && Object.values(selectTable)[0].is_split === 0){
  //         toast.error("Table is already reserved");
  //         return false;
  //       }
  //       if(waiterOd && waiterOd.length && (waiterOd.includes(selectedDeliveryType.id) && !waiterSelected)){
  //         toast.error("Please select waiter");
  //         return false;
  //       }
  //       setOrderDetails((curr)=>({
  //         ...curr,
  //         table: newtable ? newtable : null,
  //         waiter: waiterSelected ? waiterSelected : null,
  //         total_guest: guestSelected ? guestSelected : 1,
  //         table_id: tableId,
  //         table_name : Object.values(selectTable)[0]?.name,
  //       }));
  //       setModal10Show(false);
  //     } else {
  //       toast.error("Please select the table first");
  //     }
  //   }else{
  //     if(waiterOd && waiterOd.length && (waiterOd.includes(selectedDeliveryType.id) && !waiterSelected)){
  //       toast.error("Please select waiter");
  //       return false;
  //     }
  //     setOrderDetails((curr)=>({
  //       ...orderDetails,
  //       waiter: waiterSelected ? waiterSelected : null,
  //     }));
  //     setModal10Show(false);
  //   }
  // };

  // const handleTableSelect = (table,index) => {
  //   if(selectTable && Object.values(selectTable)[0]?.is_split === 1 && Object.values(selectTable)[0]?.is_reserved === 0){
  //     toast.error("Please un split the selected split table");
  //     setTempIndex(null)
  //   }else{
  //     setTempIndex(index)
  //     if(Object.keys(selectTable).includes(table.id.toString())){
  //       setSelectTable((curr) => {
  //         const tabel = {
  //           ...curr,
  //         };
  //         delete tabel[table.id]
  //         return tabel;
  //       });
      
  //     }else{
  //       if(table.is_split && table.is_reserved){
  //         setSelectTable({
  //           [table.id]:{
  //             ...table,
  //           name: table?.name + "-B",
  //           is_color:"",
  //           is_merge:0
  //           }
  //         });
  //       }else{
  //         if(table.is_reserved){
  //           setSelectTable({
  //             [table.id]: {
  //               ...table,
  //               is_split:0,
  //               is_merge:0,
  //               is_color:"",
  //             },
  //           });
  //         }else{
  //           setSelectTable({
  //             [table.id]: {
  //               ...table,
  //               is_split:0,
  //               is_reserved: 0,
  //               is_merge:0,
  //               is_color:"",
  //             },
  //           });
  //         }
  //       }
  //     }
  //   }
  // };

  // // multiple table select
  // const handleTableMulitpleSelect = (table,ind) => {
  //   if(table.is_split === 1 || table.is_reserved){
  //     toast.error("You can't select split/reserve table on multiselect");
  //   }else{
  //     if(Object.keys(selectTable).includes(table.id.toString())){
  //       const newTable = [...tables];
  //       if (ind !== -1) {
  //         [newTable[ind]] = [ {...newTable[ind],is_merge : 0,is_color:""}];
  //       }
  //       setTables(newTable);
  //       setSelectTable((curr) => {
  //         const tabel = {
  //           ...curr,
  //         };
  //         delete tabel[table.id]
  //         return tabel;
  //       });         
  //     }else {
  //       // let selectedTable = [table,...Object?.values(selectTable)];
  //       const newTable = [...tables];
  //       [newTable[ind]] = [ {...newTable[ind],is_merge : 1}];
  //       setSelectTable((curr) => {
  //         const mergetabel = {
  //           ...curr,
  //           [newTable[ind].id]: {
  //             ...newTable[ind],
  //             is_color: remainingPallete[0],
  //             is_merge : 1,
  //             is_reserved:0,
  //             is_split:0
  //           },
  //         };
  //         return mergetabel;
  //       });
  //       setTables(newTable);
  //     }
      
  //   }
  // };

  // // split table
  // const handleSplit = () => {
  //   if (Object.keys(selectTable)?.length > 0) {
  //     if(multiSelect === true){
  //       toast.error("Please turn off multi select option")
  //     }else{
  //       // const index2 = tables.findIndex((table) => Object.values(selectTable)[0].id === (table.id));
  //       const index2 = tempIndex;
  //       if(tables[index2]?.is_split === 1 && tables[index2]?.is_reserved === 0){
  //       if (index2 !== -1) {
  //         const newTable = [...tables];
  //         [newTable[index2]] = [ {...newTable[index2],is_split : 0}];
  //         setTables(newTable);
  //       }
  //        setSelectTable({});
  //       }else if( tablesApi[index2]?.is_split === 1 && tablesApi[index2]?.is_reserved === 1){
  //         toast.error("Already Split");
  //         setSelectTable({});
  //       }else if(tables[index2]?.is_reserved === 1){
  //         if(tables[index2]?.id === Object.values(selectTable)[0]?.id && Object.values(selectTable)[0]?.is_split){
  //           if (index2 !== -1) {
  //             const newTable = [...tables];
  //             [newTable[index2]] = [ {...newTable[index2],is_split : 0,}];
  //             setTables(newTable);
  //           }
  //           setSelectTable({});
  //         }else{
  //           if (index2 !== -1) {
  //             const newTable = [...tables];
  //             [newTable[index2]] = [ {...newTable[index2],is_split : 1,}];
  //             setTables(newTable);
  //           }
  //           setSelectTable({
  //             [Object.values(selectTable)[0].id]: {
  //               ...Object.values(selectTable)[0],
  //               name: Object.values(selectTable)[0].name + "-B",
  //               is_color:"",
  //               is_merge:0,
  //               is_split:1,
  //               is_reserved:1
  //             },
  //           });
  //         }
  //       }else{
  //         if (index2 !== -1) {
  //           const newTable = [...tables];
  //           [newTable[index2]] = [ {...newTable[index2],is_split : 1, is_reserved: 0}];
  //           setTables(newTable);
  //         }
  //         setSelectTable({
  //           [Object.values(selectTable)[0].id]: {
  //             ...Object.values(selectTable)[0],
  //             name: Object.values(selectTable)[0].name + "-A",
  //             is_color:"",
  //             is_merge:0,
  //             is_split:1,
  //             is_reserved:0
  //           },
  //         });
  //       }

  //     }
  //   } else {
  //     toast.error("Please Select Table");
  //   }
  // };

  // //waiter search
  // const handleSearchWaiter = (e) =>{
  //   const search = e.target.value.toLowerCase();
  //   if(search?.length){
  //     const searchedWaiter = waiters.waiterList && waiters.waiterList.filter((waiter) => waiter.name.toLowerCase().includes(search));
  //     setWaiters({
  //       ...waiters,
  //       searchedWaiter: searchedWaiter,
  //     })
  //   }else{
  //     setWaiters({
  //       ...waiters,
  //       searchedWaiter: null,
  //     })
  //   }
  // }

  // const waitersList = waiters.searchedWaiter || waiters.waiterList;

  // const handleTranfer = () =>{
  //   if (Object.keys(selectTable)?.length > 1) {
  //     if(multiSelect === true){
  //       const index1 = tables.findIndex((table) => Object.keys(selectTable)[0] === (table.id));
  //       const index2 = tables.findIndex((table) => Object.keys(selectTable)[1] === (table.id));
  //       if (index1 !== -1 && index2 !== -1) {
  //         const newTable = [...tables];
  //         [newTable[index1], newTable[index2]] = [newTable[index2], newTable[index1]];
  //         setTables(newTable);
  //       }
  //     }else{
  //       toast.error("Please select table from multiselect option")
  //     }
  //   }else{
  //     toast.error("Please select two tables to tranfer")
  //   }
  // }

  return (
    <Modal
      show={modal10Show}
      onHide={() => setModal10Show(false)}
      size="table"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        {/* Modal Body */}
        <div style={{padding:"0.5rem"}}>
          <form onSubmit={(e)=>handleTableSubmit(e)} autoComplete="off">
            <div className="main row">
              <div className="col-8">
                <h4 className="font-weight bold  table-header">Select Table</h4>
              </div>
              <div className="col-8">
                <div className="flex-row d-flex justify-content-between border-bottom pb-0 align-items-center">
                  <h6 className="font-weight bold  table-header">
                    Tables List
                  </h6>
                  <Switch
                    checked={multiSelect}
                    name="status"
                    onChange={(e) => {
                      setMultiSelect(!multiSelect);
                    }}
                    uncheckedIcon={
                      <label
                        className="switchIcon switchUnchecked"
                        style={{ paddingRight: 5 }}
                      >
                        Select One
                      </label>
                    }
                    checkedIcon={
                      <label className="switchIcon" style={{ paddingLeft: 5 }}>
                        Multi Select
                      </label>
                    }
                    height={22}
                    width={85}
                    offColor="#939393"
                    className={`float-left mb-1 ${multiSelect ? "switch-btn" : "switch-btn2"}`}
                  />
                </div>
                <ul style={{ padding: 0, listStyle: "none" }}>
                  <div
                    className="d-flex border-bottom align-items-center px-1 py-2 bill_modal_scroll"
                    style={{
                      overflowy: "hidden",
                      flexWrap: "nowrap",
                      gap: "0.55rem",
                    }}
                  >
                  {getTableFloor &&
                    getTableFloor.map((floor,index) => (
                      <li key={index}
                        style={{ whiteSpace: "nowrap",}}
                        className={`floorTable mr-2 text-capitalize rounded-top px-3 py-1
                        ${
                          tablefloor && tablefloor?.id === floor?.id
                            ? "floorActive table-floor"
                            : ""
                        }`}
                        onClick={(e) => setTableFloor(floor)}
                      >
                        {floor.name}
                      </li>
                    ))}
                  </div>
                  <div className="res-table row my-1 mx-0">
                   {
                    tables && tables?.length > 0 && tables.map(
                      (table,index) => tablefloor && parseInt(table.floor_id) === parseInt(tablefloor.id) &&
                      (
                        <div key={index}
                          className="col-3 d-flex align-items-center justify-content-center my-1"
                        >
                          <li
                            className={`d-flex align-items-center justify-content-center modal--table-item ${(table.is_reserved === 2 || tableLoading) && "disable_table"} ${table.is_reserved && "table-reserve"} px-3
                              ${
                              Object.keys(selectTable).includes(String(table.id))
                                ? "selected-table"
                                : ""
                              }`}
                              style={{backgroundColor:table?.is_color, paddingTop: "0.8rem", paddingBottom:"0.8rem"}}  
                              onClick={() =>{
                              if((table.is_split === 1 ? table.is_reserved === 2 : (table.is_reserved && table?.is_merge)) || tableLoading){

                              }else{
                                multiSelect ?
                                handleTableMulitpleSelect(table,index)
                                :
                                handleTableSelect(table, index)
                              }
                            }}
                          >
                          {table.is_split === 1 ? (
                            <>
                              {
                                (table.is_split && table.is_reserved === 2) ? 
                                <span className={`${table.is_reserved ? "table-tooltip" : "table-tooltip-none"}`}>Table split & reserved</span>
                                :
                                (table.is_split && table.is_reserved === 1) ?
                                <span className={`${table.is_split ? "table-tooltip" : "table-tooltip-none"}`}>Table split and half reserve</span>
                                :
                                <span className={`${table.is_split ? "table-tooltip" : "table-tooltip-none"}`}>Table split</span>
                              }
                              <span className="split d-flex justify-content-end">
                                <span
                                className={" halfTable" }
                                >
                                  {table.name+"A"}
                                </span>
                                <LeftHalfTable/>
                              </span>

                              <span className="split d-flex justify-content-start">
                                <span
                                className={" halfTable"}
                                >
                                  {table.name+"B"}
                                </span>
                                <RightHalfTable/>
                              </span>
                            </>
                            ) : (
                              <>
                                {
                                  (table?.is_merge && table.is_reserved) ?
                                  <span className={`${table.is_reserved ? "table-tooltip" : "table-tooltip-none"}`}>Table merged & reserved</span>
                                  :
                                  (table?.is_merge) ?
                                  <span className={`${table.is_merge ? "table-tooltip" : "table-tooltip-none"}`}>Table merged</span>
                                  :
                                  <span className={`${table.is_reserved ? "table-tooltip" : "table-tooltip-none"}`}>Table reserved</span>
                                }
                                <span
                                  className="tableName"
                                  style={{color: table?.is_color ? table.is_color : "white"}}
                                >
                                  {table.name}
                                </span>
                                <FullTable/>
                              </>
                            )
                          }

                          {
                            table.is_reserved === 2 ||  table.is_reserved === 1 ? 
                            <span className="reservation_time">Occ. from {getReseredTime(table && table.updated_at1)}</span>
                            :
                            ""
                          }
                          </li>
                        </div>
                      )
                    )
                   }

                  </div>
                </ul>

                {/* //footer// */}
                <div className="flex-row d-flex justify-content-end my-2 mt-4">
                  <button
                    type="button"
                    className="btn fw-bold btn-table"
                    style={{ backgroundColor: "#939393", color: "#fff" }}
                    onClick={handleSplit}
                  >
                   {
                     selectTable && Object.values(selectTable)[0]?.is_split ?
                     "Un Split Table"  : " Split Table"
                   }
                  </button>
                </div>
              </div>
              <div className="col-4 border-left d-flex justify-content-between"
              style={{
                flexDirection:"column",
              }}
              >
                <div className="col ml-2">
               {/* <div className="col-12 ">
                
                <label className="mb-1 col-form-label class-variants" style={{color:"#0a8d6e"}}>
               
                <input
                disabled = {order_id}
                type="checkbox"
                className="form-check-input pointer-cursor mr-2"
                name="reservation"
                value = "1"
                onChange={(e)=>{
                  setOrderDetails({
                    ...orderDetails,
                    reservation: orderDetails.reservation === 1 ? 0 : 1,
                  })
                }}
                checked ={
                  orderDetails.reservation ? 1 : 0
                }

                />
                Table Reservation
                </label>
                <br/>
                 {
                  orderDetails.reservation === 1 &&(
                    <>
                
                    <label
                    for="recipient-name"
                    className="col-form-label fw-bold class-variants"
                  >
                    Date
                  </label>
                  <DatePicker
                   required={true}
                    minDate={new Date()}
                    selected={startDate}
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="form-control sm-text py-2 t-mb-15 mb-md-0"
                    shouldCloseOnSelect={true}
                  />
                    <div className="col-12 ">
                    <label
                      for="recipient-name"
                      className="col-form-label fw-bold class-variants"
                    >
                      Time
                    </label>
                    <div className="d-flex align-items-center">
                    <span className="col mr-2">
                    <DatePicker
                    minDate={new Date().getTime()}
                    selected={startTime}
                    value={startTime}
                    onChange={(date) =>  setStartTime(date.getTime())}
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                     showTimeSelect
                     showTimeSelectOnly
                     dropdownMode="select"
                     className="form-control sm-text py-2 t-mb-15 mb-md-0 col-6"
                     shouldCloseOnSelect={true}
                   />
                   </span>

                   <span className="col ml-1">
                   <DatePicker
                  minDate={new Date().getTime()}
                  selected={endTime}
                  value={endTime}
                  onChange={(date) =>  setEndTime(date.getTime())}
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                  showTimeSelect
                  showTimeSelectOnly
                  dropdownMode="select"
                  className="form-control sm-text py-2 t-mb-15 mb-md-0 col-6"
                  shouldCloseOnSelect={true}
                  />
                  </span>
                  </div>
                  </div>
                    </>
                  )
                 }
                  
                 </div> */}
                  <div className="col-12" style={{marginTop:"-0.6rem"}}>
                    <label
                      htmlFor="guest"
                      className="col-form-label fw-bold class-variants"
                    >
                      Guest
                    </label>
                    <div style={{marginLeft:"0.65rem"}} className="w-50 mb-1 d-flex align-items-center position-relative">
                      <button type="button" className="btn btn-decrement" onClick={()=> guestSelected == 1 ? 1 : setGuestSelected(Number(guestSelected) - 1)}> − </button>
                        <input
                          type="number"
                          id="guest"
                          min="0"
                          step="1"
                          onKeyDown={(evt) => ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) && evt.preventDefault()}
                          onWheel={(e) => e.target.blur()}  
                          className="form-control table-text text-center lg-text p-2 px-3 rounded-xlg"
                          value={guestSelected}
                          onChange={(e) => setGuestSelected(e.target.value)}
                          placeholder={1}
                          required
                        />
                      <button type="button" className="btn btn-primary btn-increment" onClick={()=> setGuestSelected(Number(guestSelected) + 1)}>+</button>
                    </div>
                    <div className="d-flex align-items-center mt-2 mb-1 flex-wrap">
                      {
                        guestVisitor && guestVisitor.map((guest, index) =>{
                          return (
                            <div key={index} className="pr-2 text-break">
                              <button type="button" className={`p-0 btn-custom rounded-sm btn btn-sm ${guest === guestSelected ? "btn-success" : "btn-primary" } table-text`} onClick={()=>{
                                setGuestSelected(guest)
                              }}
                              >
                                {guest}
                              </button>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                  <div className="col-12">
                    <label
                      htmlFor="waiter"
                      className="col-form-label fw-bold class-variants "
                    >
                      Waiter
                    </label>
                    <div className="mb-3">
                      <input
                        className="form-control table-text rounded-sm"
                        id="waiter"
                        placeholder='search waiter'
                        onChange={(e)=>handleSearchWaiter(e)}
                      />
                    </div>
                    <div className="mb-1 modal-scroll">
                      <div  className="row m-0">
                        {
                          waitersList && waitersList.map((waiter, index) =>{
                            return (
                              <div key={index} className={`${index % 2 === 0 ? "pl-0" : "pr-0"} col-6 mb-2`}>
                                <button disabled={order_id && (parseInt(getSystemSettings(generalSettings, "enable_waiter_selection")) !== 1)} type="button" className={`w-100 btn btn-sm ${waiter.id === waiterSelected?.id ? "btn-success" : "btn-primary"} table-text`} onClick={()=> setWaiterSelected(waiterSelected?.id === waiter?.id ? null : waiter)}>
                                  {waiter.name} {waiter.id === waiterSelected?.id && "✔"}
                                </button>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col ml-2 d-flex justify-content-end"
                style={{
                  flexDirection:"column",
                }}
                >
                  <Modal.Footer
                    style={{
                      borderTop: "none",
                      display:"block",
                      padding: "0.3rem 0rem",
                    }}
                  >
                    <div className="row mt-1" style={{ borderTop: "none", padding:"0"}}>
                      <div className="col-6 p-0 pr-2">
                        <button
                          type="submit"
                          className="btn w-100 btn-down fw-bold rounded-25 mr-2"
                          style={{
                            backgroundColor: "#0a8d6e",
                            color: "#fff",
                            fontSize: "0.85rem",
                          }}
                        >
                          CONFIRM
                        </button>
                      </div>
                      <div className="col-6 p-0" >
                        <button
                          type="button"
                          className="btn w-100 fw-bold btn-down rounded-25 "
                          style={{
                            backgroundColor: "#939393",
                            color: "#fff",
                            fontSize: "0.85rem",
                          }}
                          onClick={() => setModal10Show(false)}
                        >
                          CANCEL
                        </button>
                      </div>
                    </div>
                  </Modal.Footer>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default memo(TableModal);
